import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: '/',
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
});

export const apiInterceptors = (store) => {
  axiosInstance.interceptors.request.use(
    (config) => {
      const token = store.getters.getToken;
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (err) => Promise.reject(err)
  );

  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error && error.response && error.response.status === 401) {
        return Promise.resolve(error.response);
      }

      return Promise.reject(error);
    }
  );
};

export default axiosInstance;
